import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import 'react-toastify/dist/ReactToastify.css';

export const setTabList = (payload) => ({
    type: TYPES.SET_TAB_LIST,
    payload,
  });

  export const setAllowedTabList = (payload) => ({
    type: TYPES.SET_ALLOWED_TAB_LIST,
    payload,
  });

  export const setSelectedModulePermission = (payload) => ({
    type: TYPES.SET_SELECTED_MODULE_PERMISSION,
    payload,
  });

  export const clearTabList = () => ({
      type: TYPES.CLEAR_TAB_LIST,
  });

  export const clearAllowedTabList = () => ({
    type: TYPES.CLEAR_ALLOWED_TAB_LIST,
  });

  export const clearSelectedModulePermission = () => ({
    type: TYPES.CLEAR_SELECTED_MODULE_PERMISSION,
  });

export const fetchtTabList = () => (dispatch) => {
  return client.getTabList().then((response) => {
    if (response.ok || response.status === 200) {
      response
        .json()
        .then((responsejson) =>
          dispatch(setTabList(responsejson.data))
        );
    }
  });
};

export const fetchtAllowedTabList = (id, branding = {}) => (dispatch) => {
  return client.getAllowedTabList(id).then((response) => {
    if (response.ok || response.status === 200) {
      response
        .json()
        .then((responsejson) => {
          
          if (Object.keys(branding).length > 0) {

            var overridenServiceRequestTab = `${branding.text.serviceRequest}s`;

            responsejson.data = responsejson.data.map(tab => {

              if (tab.name == "Service Requests" && tab.name !== overridenServiceRequestTab) {
                var overridenTab = { ...tab, name: overridenServiceRequestTab, description: overridenServiceRequestTab };
                return overridenTab;
              }
              else {
                return tab;
              }
            });
          }

          const user = JSON.parse(localStorage.getItem('user'));
          const roleName = user.roles[0].role.name;
          if (roleName === "Occupant" || roleName === "Realtor" || roleName === "Home Owner") {
            if (responsejson.data.length > 0) {
              let filterNote = responsejson.data.filter(x => x.name === "Notes");
              if (filterNote.length == 0) {
                responsejson.data.push({ name: "Notes" })
              }
            }
            dispatch(setAllowedTabList(responsejson.data))
          }
          else {
            dispatch(setAllowedTabList(responsejson.data))
          }
        }
        );
    }
  });
};